import { PBRMaterial } from "@babylonjs/core/Materials/PBR/pbrMaterial";
import { SceneLoader } from "@babylonjs/core/Loading/sceneLoader";
import { Scene } from "@babylonjs/core/scene";
import { LightHelper } from "./LightHelper";
import { MirrorTexture } from "@babylonjs/core/Materials/Textures/mirrorTexture";
import { Plane } from "@babylonjs/core/Maths/math.plane";
import { on, trigger } from "./EventManager";
import { PhysicsAggregate } from "@babylonjs/core/Physics/v2/physicsAggregate";
import { PhysicsShapeType, PointerDragBehavior, Vector3 } from "@babylonjs/core";
import { HoverHelper } from "./HoverHelper";

export abstract class ModelLoader {

  public static LoadModel(filepath: string, scene: Scene) {

    SceneLoader.AppendAsync('./', filepath, scene).then((model) => {

      let root = model.meshes[0]
      root.getChildMeshes().forEach((mesh) => {
        mesh.setParent(null)
      })
      root.dispose()

      // Create mirror texture
      let floorMirror = new MirrorTexture('floorMirror', 512)
      floorMirror.mirrorPlane = new Plane(0, -1, 0, 0)
      floorMirror.adaptiveBlurKernel = 32
      floorMirror.refreshRate = 2

      model.meshes.forEach((mesh) => {
        if (mesh.name === "Floor") {
          (mesh.material as PBRMaterial).reflectionTexture = scene.getTextureByName('floorMirror');
          new PhysicsAggregate(mesh, PhysicsShapeType.BOX, { mass: 0 }, scene)
        } else {
          floorMirror.renderList?.push(mesh)
          LightHelper.MakeShadowCaster(mesh);
        }
        if (mesh.name === 'GM-Dummy') {
          // save start rotation as clone
          let startRotation = mesh.rotationQuaternion!.clone();

          // drag mechanic
          // let dragBehavior = new PointerDragBehavior();
          // dragBehavior.onDragStartObservable.add(() => {
          //   scene.onBeforePhysicsObservable.addOnce(() => {
          //     mesh.physicsBody!.disablePreStep = false;
          //     mesh.physicsBody?.setLinearVelocity(Vector3.Zero())
          //     mesh.physicsBody?.setAngularVelocity(Vector3.Zero())
          //   })
          // });
          // dragBehavior.onDragEndObservable.add(() => {
          //   mesh.physicsBody!.disablePreStep = true;
          // })
          // mesh.addBehavior(dragBehavior)

          // reset handling
          on('reset', () => {
            mesh.physicsBody!.disablePreStep = false;
            mesh.setAbsolutePosition(new Vector3(0, 1.5, 0))
            mesh.rotationQuaternion = startRotation.clone()
            mesh.physicsBody?.setLinearVelocity(Vector3.Zero())
            mesh.physicsBody?.setAngularVelocity(Vector3.Zero())
            scene.onAfterPhysicsObservable.addOnce(() => {
              mesh.physicsBody!.disablePreStep = true;
            })
          })

          // move mesh and activate aggregate
          mesh.setAbsolutePosition(new Vector3(0, 1.5, 0))
          new PhysicsAggregate(mesh, PhysicsShapeType.MESH, { mass: 1, restitution: .75 }, scene)
        }
        mesh.receiveShadows = true;
      })
      trigger('hideLoadingScreen')
    })
  }

}